<template lang="pug">
div
  v-responsive.playerContainer(:aspect-ratio="16 / 9" )
    //- OverlayPlayer.inactiveVideo(v-if="includeIntro && intro && selectedTheme && !selectedTheme.excludeIntro" @donePlaying="donePlaying" :video="intro" :class="{activeVideo: 'intro' === selectedElement.id }" key="intro")
    div(v-for="(element, index) in getPlayableTimelineElements")
      OverlayPlayer.inactiveVideo(:video="element" ref="bus" @timeUpdate="timeUpdate" @donePlaying="donePlaying" :class="{activeVideo: element.id === selectedElement.id }" :key="element.id")
    //- OverlayPlayer.inactiveVideo(:video="outro" :class="{activeVideo: 'outro' === selectedElement.id }" key="outro")
  v-toolbar.mt-2.px-0.toolbar(dense, flat, color="transparent")
    v-btn(fab depressed x-small color="accent" @click="playTimeline")
      v-icon(color="white") {{!isPlaying ? 'mdi-play' : 'mdi-pause'}}
    span.ml-4(v-if="fullMotionLength && currentTimePosition") {{currentTimePosition}} / {{ fullMotionLength }}
    
</template>

<script>
import urlFormat from "@/utils/urlFormat";
import { fmtMSS } from "@/utils/format";
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import { EventBus } from "@/event-bus";
import OverlayPlayer from "@/components/player/OverlayPlayer";
export default {
  name: "MotionPlayer",
  components: {
    OverlayPlayer,
  },
  data() {
    return {
      isPlaying: false,
    };
  },
  watch: {
    selectedElement: function (newElement) {
      EventBus.$emit("pause", undefined);
      if (this.isPlaying) {
        EventBus.$emit("resetPlay", newElement);
      }
      this.timeUpdate({ time: 0, clipId: newElement.id });
    },
  },
  computed: {
    ...mapFields("create", {
      includeIntro: "motionSettings.includeIntro",
      selectedTheme: "selectedTheme",
      selectedElement: "selectedElement",
      currentTimePosition: "currentTimePosition",
    }),
    ...mapGetters({
      intro: "create/intro",
      outro: "create/outro",
      defaultVideo: "create/defaultVideo",
      fullMotionLength: "create/fullMotionLength",
      getPlayableTimelineElements: "create/getPlayableTimelineElements",
    }),
  },

  methods: {
    ...urlFormat,
    fmtMSS,
    playTimeline() {
      if (this.isPlaying) {
        this.isPlaying = false;
        EventBus.$emit("pause", this.selectedElement);
      } else {
        this.isPlaying = true;
        EventBus.$emit("play", this.selectedElement);
      }
    },
    donePlaying(item) {
      this.isPlaying = false;
      const currentIndex = this.getPlayableTimelineElements.findIndex(
        (el) => el.id === item.id
      );

      const nextItem = this.getPlayableTimelineElements[currentIndex + 1];
      if (nextItem) {
        this.selectedElement = nextItem;
        EventBus.$emit("play", nextItem);
        this.isPlaying = true;
      }
    },
    timeUpdate(info) {
      let currentTime = info.time;
      const currentIndex = this.getPlayableTimelineElements.findIndex(
        (el) => el.id === info.clipId
      );
      if (currentIndex > 0) {
        const elementsLength = this.getPlayableTimelineElements
          .slice(0, currentIndex)
          .map((item) => item.length);
        const reducer = (accumulator, curr) => accumulator + curr;
        const result = elementsLength.reduce(reducer);
        currentTime = info.time + result;
      }

      this.currentTimePosition = this.fmtMSS(currentTime, true);
    },
    updateMotionLength() {
      if (this.selectedTheme && this.getPlayableTimelineElements) {
        this.currentTimePosition = this.fmtMSS(0, true);
      } else {
        return this.fmtMSS(2, true);
      }
    },
  },
  created() {
    this.updateMotionLength();
  },
};
</script>
<style lang="sass" scoped>

.inactiveVideo
  opacity: 0
  position: absolute
  top: 0
  bottom: 0
  right: 0
  left: 0
.activeVideo
  opacity: 1 !important
</style>
